import { Button, Heading, ModalContent, ModalFooter } from '@grupoboticario/flora-react';
import { styled, theme, utils } from 'ui/theme';

export const ShareGuideCycleStyle = {
  ModalShareGuide: styled(ModalContent)`
    ${utils.media.max('s')`
      width: 100%;
    `}
  `,

  ModalTitle: styled(Heading)`
    ${utils.media.max('s')`
      width: calc(100% - 40px);
      word-wrap: break-word;
    `}
  `,

  CopyButton: styled(Button)`
    font-family:
      Space Grotesk,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica,
      Arial,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol;
    :focus-visible {
      box-shadow: inset 0 0 0 1px ${theme.colors.action.navigation.standard.static};
    }
  `,

  ShareButton: styled(Button)`
    font-family:
      Space Grotesk,
      -apple-system,
      BlinkMacSystemFont,
      Segoe UI,
      Helvetica,
      Arial,
      sans-serif,
      Apple Color Emoji,
      Segoe UI Emoji,
      Segoe UI Symbol;

    align-items: center;
    display: inline-flex;
    gap: ${theme.space[2]};
    justify-content: center;

    svg {
      flex: 0 0 ${theme.sizes[4]};
    }

    :focus-visible {
      box-shadow: none;
    }
  `,

  ModalFooterMobile: styled('div')`
    padding: 20px;
  `,

  ModalFooterShareGuide: styled(ModalFooter)`
    ${utils.media.max('s')`
        flex-direction: column-reverse;
    `}
  `,
};
